import React from 'react';
import classNames from 'classnames';
import styles from './app-launcher.css';

// Importing original image icons from the project
import studioLogo from '../menu-bar/rc_logo2-removebg-preview.png';
import sandboxImage from '../../../static/assets/app_launcher_logos/Sandbox.png';
import audImage from '../../../static/assets/app_launcher_logos/Aud.png';
import bitmapImage from '../../../static/assets/app_launcher_logos/Bitmap.png';
import boardImage from '../../../static/assets/app_launcher_logos/Board.png';
import gamesImage from '../../../static/assets/app_launcher_logos/Games.png';
import htmlImage from '../../../static/assets/app_launcher_logos/HTML.png';
import letterGameImage from '../../../static/assets/app_launcher_logos/Letter Game.png';
import mlImage from '../../../static/assets/app_launcher_logos/ML.png';
import pyImage from '../../../static/assets/app_launcher_logos/PY.png';
import satImage from '../../../static/assets/app_launcher_logos/Sat.png';

// SVG Icons for a professional look
const Icons = {
    Sandbox: () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
            <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
    ),
    Compiler: () => (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 18L22 12L16 6M8 6L2 12L8 18" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Python: () => (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="4" width="20" height="16" rx="3" stroke="white" strokeWidth="2"/>
            <path d="M7 9L10 12L7 15" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="12" y1="15" x2="17" y2="15" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        </svg>
    ),
    Whiteboard: () => (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="15" rx="2" stroke="white" strokeWidth="2"/>
            <path d="M8 21H16" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path d="M12 18V21" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path d="M7 8C7 8 8 7 10 7C12 7 12 9 14 9C16 9 17 8 17 8" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    ),
    Game: () => (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12H10M8 10V14M15 11H15.01M18 13H18.01" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <rect x="2" y="6" width="20" height="12" rx="3" stroke="white" strokeWidth="2"/>
        </svg>
    ),
    TM: () => (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" strokeWidth="2"/>
            <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 6V7M12 17V18M6 12H7M17 12H18" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Close: () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
    ),
    Audio: () => (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" fill="white"/>
        </svg>
    ),
    Bitmap: () => (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" fill="white"/>
        </svg>
    ),
    Sat: () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9H3m9 9a9 9 0 0 1-9-9m9 9c1.66 0 3-4.03 3-9s-1.34-9-3-9m0 18c-1.66 0-3-4.03-3-9s1.34-9 3-9"></path>
        </svg>
    )
};

class AppLauncher extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            searchTerm: ''
        };
        this.launcherRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.isOpen !== prevState.isOpen) {
            if (this.state.isOpen) {
                document.addEventListener('mousedown', this.handleClickOutside, true);
            } else {
                document.removeEventListener('mousedown', this.handleClickOutside, true);
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside, true);
    }

    handleClickOutside(event) {
        if (this.launcherRef.current && !this.launcherRef.current.contains(event.target)) {
            this.setState({ isOpen: false });
        }
    }

    handleAppClick(app) {
        this.setState({ isOpen: false });
        if (app.url) {
            window.open(app.url, '_blank', 'noopener,noreferrer');
        }
    }

    renderAppItem(app) {
        return (
            <div 
                key={app.id} 
                className={styles.appItem} 
                onClick={() => this.handleAppClick(app)}
            >
                <div className={styles.appIconContainer} style={{ background: app.gradient }}>
                    {app.image ? (
                        <img src={app.image} alt={app.name} className={styles.appImage} />
                    ) : (
                        <div className={styles.appIconSvg}>{app.icon()}</div>
                    )}
                </div>
                <span className={styles.appItemName}>{app.name}</span>
            </div>
        );
    }

    render() {
        const apps = [
            { id: 'Sandbox', name: 'TIF Sandbox', image: sandboxImage, url: 'https://sandbox.tiflabs.in/' },
            { id: 'tm', name: 'Teachable Machine', image: mlImage, url: 'https://teachablemachine.withgoogle.com/train' },
            { id: 'compiler', name: 'HTML Compiler', image: htmlImage, url: 'https://app.tifstudio.in/html-compiler/' },
            { id: 'python', name: 'Python Compiler', image: pyImage, url: 'https://app.tifstudio.in/python-compiler/' },
            { id: 'whiteboard', name: 'TIF Whiteboard', image: boardImage, url: 'https://app.tifstudio.in/white-board/' },
            { id: 'audio', name: 'TIF Audio', image: audImage, url: 'https://app.tifstudio.in/tif-audio/' },
            { id: 'bitmap', name: 'TIF BITMap', image: bitmapImage, url: 'https://app.tifstudio.in/tif-bitmap/' },
            { id: 'sat', name: 'OrbitX', image: satImage, url: 'https://app.tifstudio.in/orbitx/' }
        ];

        const games = [
            { id: 'letter_game', name: 'Letter Game', image: letterGameImage, url: 'https://app.tifstudio.in/letter-game/' },
            { id: 'typing_game', name: 'Typing Game', image: gamesImage, url: 'https://app.tifstudio.in/typing-game/' }
        ];

        const filteredApps = apps.filter(app => app.name.toLowerCase().includes(this.state.searchTerm.toLowerCase()));
        const filteredGames = games.filter(app => app.name.toLowerCase().includes(this.state.searchTerm.toLowerCase()));

        return (
            <div className={styles.appLauncherContainer} ref={this.launcherRef} id="app-launcher-root">
                <button 
                    className={classNames(styles.launcherButton, { [styles.active]: this.state.isOpen })}
                    onClick={() => this.setState({ isOpen: !this.state.isOpen })}
                    aria-label="App Launcher"
                >
                    <div className={styles.waffleIcon}>
                        {[...Array(9)].map((_, i) => (
                            <div key={i} className={styles.dot}></div>
                        ))}
                    </div>
                </button>

                {this.state.isOpen && (
                    <div className={styles.launcherDropdown}>
                        <div className={styles.dropdownHeader}>
                            <div className={styles.searchWrapper}>
                                <span className={styles.searchIcon}>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="11" cy="11" r="8"></circle>
                                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                    </svg>
                                </span>
                                <input 
                                    type="text" 
                                    className={styles.searchInput} 
                                    placeholder="Search apps..." 
                                    value={this.state.searchTerm}
                                    onChange={(e) => this.setState({ searchTerm: e.target.value })}
                                    autoFocus
                                />
                            </div>
                        </div>
                        
                        <div className={styles.scrollArea}>
                            {filteredApps.length > 0 && (
                                <div className={styles.gridSection}>
                                    <h2 className={styles.sectionTitle}>Apps</h2>
                                    <div className={styles.appsGrid}>
                                        {filteredApps.map(app => this.renderAppItem(app))}
                                    </div>
                                </div>
                            )}

                            {filteredGames.length > 0 && (
                                <>
                                    <div className={styles.divider}></div>
                                    <div className={styles.gridSection}>
                                        <h2 className={styles.sectionTitle}>Games</h2>
                                        <div className={styles.appsGrid}>
                                            {filteredGames.map(app => this.renderAppItem(app))}
                                        </div>
                                    </div>
                                </>
                            )}
                            
                            {filteredApps.length === 0 && filteredGames.length === 0 && (
                                <div className={styles.emptyState}>No results found for "{this.state.searchTerm}"</div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default AppLauncher;
